import { makeTranslationHelpers } from '@/hooks/useTranslation';

const { useTranslation: useInformationTranslation, Translation } =
  makeTranslationHelpers('page.companyReport.information');

export { useInformationTranslation, Translation as InformationTranslation };
